import { Dropdown } from 'react-bootstrap';
import { faFileExport, faArchive, faEdit, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const ActionDropdownItems = () => {
  return (
    <>
      <Dropdown.Item eventKey="4" className="text-secondary">
      <FontAwesomeIcon icon={faEdit} className="fs-9 me-2" />
        Edit</Dropdown.Item>
      <Dropdown.Item eventKey="4" className="text-secondary">
      <FontAwesomeIcon icon={faFileExport} className="fs-9 me-2" />
        Export</Dropdown.Item>
      <Dropdown.Item eventKey="4" className="text-secondary">
      <FontAwesomeIcon icon={faArchive} className="fs-9 me-2" />
        Archive
      </Dropdown.Item>
    </>
  );
};

export default ActionDropdownItems;
